import React from 'react';
import { getAugmentDefaultSvgPath, AUGMENT_KIND } from '../utils/augmentAssets';
import './helpIconTokens.css';

export const MATCH_VOTE_ICON_SVG = '/vote-ballot.svg';
export const RARITY_ICON_SVG = '/rarity.svg';
/** @deprecated Use {@link RARITY_ICON_SVG} */
export const CONSENSUS_ICON_SVG = RARITY_ICON_SVG;

const HELP_INLINE_ICON_CLASS = 'help-inline-icon';

const TOKEN_META = {
  consensus: { src: RARITY_ICON_SVG, alt: 'rarity' },
  vote: { src: MATCH_VOTE_ICON_SVG, alt: 'vote' },
  m: {
    src: getAugmentDefaultSvgPath('m', AUGMENT_KIND.MATCH),
    alt: 'Multiplier'
  }
};

/** Replace `{{consensus}}` / `{{vote}}` / `{{m}}` tokens with inline icons for help copy. */
export function renderHelpTextWithIcons(text) {
  const parts = String(text ?? '').split(/(\{\{(?:consensus|vote|m)\}\})/g);
  return parts.map((part, index) => {
    const match = part.match(/^\{\{(consensus|vote|m)\}\}$/);
    if (!match) return part;
    const meta = TOKEN_META[match[1]];
    return (
      <img
        key={`${match[1]}-${index}`}
        src={meta.src}
        alt={meta.alt}
        className={HELP_INLINE_ICON_CLASS}
      />
    );
  });
}
